module.exports = __webpack_public_path__ + "static/media/reg9ru.9afc81c7.pdf";